import { useQuery } from 'react-query';
import { useFirebase } from 'components/Firebase/index.js';
import { useOrgId } from 'hooks/index.js';
import { vodUrl } from '../../../../../client-config.js';
import { ITEMS_PER_PAGE } from 'pages/Distribution/constants.js';

const useDistributionContainersQuery = ({ distributionPageId, filterBy, sortBy, sortOrder, search, page, pageSize = ITEMS_PER_PAGE } = {}, options = {}) => {
  const firebase = useFirebase();
  const orgId = useOrgId();

  return useQuery({
    enabled: !!orgId,
    queryKey: ['distribution-containers', orgId, { distributionPageId, filterBy, search, page, pageSize, sortBy, sortOrder }],
    queryFn: async () => {
      const idToken = await firebase.getIdToken();
      const offset = (page - 1) * pageSize;

      const fetchUrl = new URL(`${vodUrl}/v1/orgs/${orgId}/distribution-containers`);
      const urlParams = new URLSearchParams({
        ...(search && { search }),
        ...(filterBy && { filterBy }),
        ...(offset && { offset }),
        ...(pageSize && { pageSize }),
        ...(distributionPageId && { pageId: distributionPageId }),
        ...(sortBy && { sortBy }),
        ...(sortOrder && { sortOrder: sortOrder.toUpperCase() }),
      });
      fetchUrl.search = urlParams.toString();

      try {
        const response = await fetch(fetchUrl.toString(), {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          },
        });
        const { ok, status } = response;
        if (ok) {
          return response.json();
        } else if (status === 404) {
          return { data: [] };
        } else {
          throw new Error({ status });
        }
      } catch (e) {
        throw e;
      }
    },
    ...options,
  });
};

export default useDistributionContainersQuery;
